module.exports = __webpack_public_path__ + "img/400(1)f.afc021e9.png";